'use strict';
import * as $j_app$002eapi$002e$002dApp$002dPage$002dSize from "./app.api.-App-Page-Size.js";
import * as $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241 from "./app.api.-App-Page-Size$$anon$1.js";
import * as $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dCreated$002dAt$0024 from "./app.data.types_admin$package$-Admin-Audit-Log-Created-At$.js";
import * as $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dId$0024 from "./app.data.types_admin$package$-Admin-Audit-Log-Id$.js";
import * as $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dCreated$002dAt$0024 from "./app.data.types_general_practice$package$-General-Practice-Created-At$.js";
import * as $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dId$0024 from "./app.data.types_general_practice$package$-General-Practice-Id$.js";
import * as $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dCreated$002dAt$0024 from "./app.data.types_out_of_stock_mediation_report$package$-Out-Of-Stock-Medication-Report-Created-At$.js";
import * as $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dId$0024 from "./app.data.types_out_of_stock_mediation_report$package$-Out-Of-Stock-Medication-Report-Id$.js";
import * as $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dCreated$002dAt$0024 from "./app.data.types_pharmacy$package$-Pharmacy-Created-At$.js";
import * as $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dId$0024 from "./app.data.types_pharmacy$package$-Pharmacy-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$1) {
  if (componentCodecs$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy1$1.sr_LazyRef__f__value;
  } else {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var destination = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(0);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var Tuple_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$();
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(Tuple_this);
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(destination, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy1$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2) {
  return (componentCodecs$lzy1$2.sr_LazyRef__f__initialized ? componentCodecs$lzy1$2.sr_LazyRef__f__value : $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2));
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$1__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$1__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$1) {
  if (componentCodecs$lzy2$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy2$1.sr_LazyRef__f__value;
  } else {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var destination = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(0);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var Tuple_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$();
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(Tuple_this);
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(destination, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy2$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$2__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2) {
  return (componentCodecs$lzy2$2.sr_LazyRef__f__initialized ? componentCodecs$lzy2$2.sr_LazyRef__f__value : $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2));
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$2__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$2__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$1) {
  if (componentCodecs$lzy3$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy3$1.sr_LazyRef__f__value;
  } else {
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var destination = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(0);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var Tuple_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$();
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(Tuple_this);
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(destination, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy3$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$3__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$2) {
  return (componentCodecs$lzy3$2.sr_LazyRef__f__initialized ? componentCodecs$lzy3$2.sr_LazyRef__f__value : $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$2));
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$3__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$3__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT4$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy4$1) {
  if (componentCodecs$lzy4$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy4$1.sr_LazyRef__f__value;
  } else {
    var acc$proxy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var m$proxy2 = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
    var componentCodecs$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
    var componentCodecs$lzy1$2$1 = componentCodecs$lzy1;
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$inlineImplementations$TupleCodec(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy1$2) => (() => $p_Lapp_api_AppPageSize$__componentCodecs$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2)))(componentCodecs$lzy1$2$1)));
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met) => m$proxy2));
    var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Tuples$().fromProduct__s_Product__s_Product(a)));
    var elem$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$2(g, f, this$4);
    var acc$proxy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, acc$proxy1);
    var m$proxy3 = $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize();
    var componentCodecs$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
    var componentCodecs$lzy2$2$1 = componentCodecs$lzy2;
    var this$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$inlineImplementations$TupleCodec(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy2$2) => (() => $p_Lapp_api_AppPageSize$__componentCodecs$2__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2)))(componentCodecs$lzy2$2$1)));
    var f$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met$2) => m$proxy3));
    var g$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Tuples$().fromProduct__s_Product__s_Product(a$2)));
    var elem$1$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$2(g$1, f$1, this$7);
    var acc$proxy3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1$2, acc$proxy2);
    var m$proxy4 = $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize();
    var componentCodecs$lzy3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
    var componentCodecs$lzy3$2$1 = componentCodecs$lzy3;
    var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$inlineImplementations$TupleCodec(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy3$2) => (() => $p_Lapp_api_AppPageSize$__componentCodecs$3__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$2)))(componentCodecs$lzy3$2$1)));
    var f$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met$3) => m$proxy4));
    var g$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a$3) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Tuples$().fromProduct__s_Product__s_Product(a$3)));
    var elem$1$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$2(g$2, f$2, this$10);
    var this$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1$3, acc$proxy3);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$12);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var unlabelled = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(jsElems);
    var Tuple_this = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3("_25", "_50", "_100");
    var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_ScalaRunTime$$anon$1(Tuple_this);
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$17);
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(unlabelled, labels);
    var f$3 = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f$3(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f$3(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f$3(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f$3(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f$3(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f$3($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f$3(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f$3(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f$3(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy4$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT4$1__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT4$1__sr_LazyRef__ALscodec_Codec };
function $p_Lapp_api_AppPageSize$__componentCodecs$4__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy4$2) {
  return (componentCodecs$lzy4$2.sr_LazyRef__f__initialized ? componentCodecs$lzy4$2.sr_LazyRef__f__value : $p_Lapp_api_AppPageSize$__componentCodecs$lzyINIT4$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy4$2));
}
export { $p_Lapp_api_AppPageSize$__componentCodecs$4__sr_LazyRef__ALscodec_Codec as $p_Lapp_api_AppPageSize$__componentCodecs$4__sr_LazyRef__ALscodec_Codec };
function $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___25;
}
export { $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___50;
}
export { $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___100;
}
export { $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize };
/** @constructor */
function $c_Lapp_api_AppPageSize$() {
  this.Lapp_api_AppPageSize$__f_$values = null;
  this.Lapp_api_AppPageSize$__f_Max = null;
  this.Lapp_api_AppPageSize$__f_toInt$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_toIntbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSize$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSizebitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSize$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSizebitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursor$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursorbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursor$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursorbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursor$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursorbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursor$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursorbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_derived$CanEqual$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_derived$CanEqualbitmap$1 = false;
  this.Lapp_api_AppPageSize$__f_derived$SCodecCodec$lzy1 = null;
  this.Lapp_api_AppPageSize$__f_derived$SCodecCodecbitmap$1 = false;
  $n_Lapp_api_AppPageSize$ = this;
  $t_Lapp_api_AppPageSize$___25 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_25", 0);
  $t_Lapp_api_AppPageSize$___50 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_50", 1);
  $t_Lapp_api_AppPageSize$___100 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_100", 2);
  this.Lapp_api_AppPageSize$__f_$values = new ($j_app$002eapi$002e$002dApp$002dPage$002dSize.$d_Lapp_api_AppPageSize.getArrayOf().constr)([$s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize()]);
  this.Lapp_api_AppPageSize$__f_Max = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
}
export { $c_Lapp_api_AppPageSize$ as $c_Lapp_api_AppPageSize$ };
$c_Lapp_api_AppPageSize$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_AppPageSize$.prototype.constructor = $c_Lapp_api_AppPageSize$;
/** @constructor */
function $h_Lapp_api_AppPageSize$() {
}
export { $h_Lapp_api_AppPageSize$ as $h_Lapp_api_AppPageSize$ };
$h_Lapp_api_AppPageSize$.prototype = $c_Lapp_api_AppPageSize$.prototype;
$c_Lapp_api_AppPageSize$.prototype.values__ALapp_api_AppPageSize = (function() {
  var this$1 = this.Lapp_api_AppPageSize$__f_$values;
  return this$1.clone__O();
});
$c_Lapp_api_AppPageSize$.prototype.toInt__Lio_scalaland_chimney_Transformer = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_toIntbitmap$1)) {
    this.Lapp_api_AppPageSize$__f_toInt$lzy1 = new $c_Lapp_api_AppPageSize$$anon$2();
    this.Lapp_api_AppPageSize$__f_toIntbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_toInt$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.given_Empty_AppPageSize__Lalleycats_Empty = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSizebitmap$1)) {
    var a = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize()));
    this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSize$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lalleycats_Empty$$anon$1(a);
    this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSizebitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_given_Empty_AppPageSize$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.given_Schema_AppPageSize__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSizebitmap$1)) {
    var this$1 = $m_Lapp_api_AppPageSize$namedEnum$();
    this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSize$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema(this$1);
    this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSizebitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_given_Schema_AppPageSize$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.tapirCodecAdminGeneralPracticesListPageCursor__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursorbitmap$1)) {
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_PageCursor$();
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy2 = $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice$package$GeneralPracticeCreatedAt$();
    var $x_4 = $x_5.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().scodecCodec__Lscodec_Codec());
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
    var \u03b4proxy4 = $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice$package$GeneralPracticeCreatedAt$();
    var $x_2 = $x_3.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy6 = $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dId$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice$package$GeneralPracticeId$();
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursor$lzy1 = $x_6.tapirCodecBinaryBase64__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lsttp_tapir_Codec($x_4, $x_2, $x_1.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy6, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_scodec$package$().scodecULID__Lscodec_Codec()), $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dId$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice$package$GeneralPracticeId$().schema__Lsttp_tapir_Schema(), this.derived$SCodecCodec__Lscodec_Codec(), this.given_Schema_AppPageSize__Lsttp_tapir_Schema());
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursorbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_tapirCodecAdminGeneralPracticesListPageCursor$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.tapirCodecAdminPharmaciesListPageCursor__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursorbitmap$1)) {
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_PageCursor$();
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy10 = $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyCreatedAt$();
    var $x_4 = $x_5.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy10, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().scodecCodec__Lscodec_Codec());
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
    var \u03b4proxy12 = $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyCreatedAt$();
    var $x_2 = $x_3.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy12, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy14 = $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dId$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$();
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursor$lzy1 = $x_6.tapirCodecBinaryBase64__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lsttp_tapir_Codec($x_4, $x_2, $x_1.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy14, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_scodec$package$().scodecULID__Lscodec_Codec()), $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dId$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyId$().given_Schema_Type__Lsttp_tapir_Schema(), this.derived$SCodecCodec__Lscodec_Codec(), this.given_Schema_AppPageSize__Lsttp_tapir_Schema());
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursorbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_tapirCodecAdminPharmaciesListPageCursor$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.tapirCodecAdminAuditLogsListPageCursor__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursorbitmap$1)) {
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_PageCursor$();
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy18 = $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$();
    var $x_4 = $x_5.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy18, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().scodecCodec__Lscodec_Codec());
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
    var \u03b4proxy20 = $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$();
    var $x_2 = $x_3.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy20, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy22 = $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dId$0024.$m_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$();
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursor$lzy1 = $x_6.tapirCodecBinaryBase64__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lsttp_tapir_Codec($x_4, $x_2, $x_1.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy22, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_scodec$package$().scodecULID__Lscodec_Codec()), $j_app$002edata$002etypes$005fadmin$0024package$0024$002dAdmin$002dAudit$002dLog$002dId$0024.$m_Lapp_data_types\uff3fadmin$package$AdminAuditLogId$().schema__Lsttp_tapir_Schema(), this.derived$SCodecCodec__Lscodec_Codec(), this.given_Schema_AppPageSize__Lsttp_tapir_Schema());
    this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursorbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_tapirCodecAdminAuditLogsListPageCursor$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.tapirCodecPharmacyOutOfStockReportsSentPageCursor__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursorbitmap$1)) {
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_PageCursor$();
    var $x_5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy26 = $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportCreatedAt$();
    var $x_4 = $x_5.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy26, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().scodecCodec__Lscodec_Codec());
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
    var \u03b4proxy28 = $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dCreated$002dAt$0024.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportCreatedAt$();
    var $x_2 = $x_3.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy28, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_data_FrameworkDateTime$().schema__Lsttp_tapir_Schema());
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3fscodec$package$();
    var \u03b4proxy30 = $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dId$0024.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportId$();
    this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursor$lzy1 = $x_6.tapirCodecBinaryBase64__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lsttp_tapir_Codec($x_4, $x_2, $x_1.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec(\u03b4proxy30, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_scodec$package$().scodecULID__Lscodec_Codec()), $j_app$002edata$002etypes$005fout$005fof$005fstock$005fmediation$005freport$0024package$0024$002dOut$002dOf$002dStock$002dMedication$002dReport$002dId$0024.$m_Lapp_data_types\uff3fout\uff3fof\uff3fstock\uff3fmediation\uff3freport$package$OutOfStockMedicationReportId$().given_Schema_Type__Lsttp_tapir_Schema(), this.derived$SCodecCodec__Lscodec_Codec(), this.given_Schema_AppPageSize__Lsttp_tapir_Schema());
    this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursorbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_tapirCodecPharmacyOutOfStockReportsSentPageCursor$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.derived$CanEqual__s_CanEqual = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_derived$CanEqualbitmap$1)) {
    this.Lapp_api_AppPageSize$__f_derived$CanEqual$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_api_AppPageSize$__f_derived$CanEqualbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_derived$CanEqual$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.derived$SCodecCodec__Lscodec_Codec = (function() {
  if ((!this.Lapp_api_AppPageSize$__f_derived$SCodecCodecbitmap$1)) {
    var m$proxy1 = $m_Lapp_api_AppPageSize$();
    var componentCodecs$lzy4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_LazyRef();
    var componentCodecs$lzy4$2$1 = componentCodecs$lzy4;
    this.Lapp_api_AppPageSize$__f_derived$SCodecCodec$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lscodec_Codec$inlineImplementations$SumCodec(m$proxy1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy4$2) => (() => $p_Lapp_api_AppPageSize$__componentCodecs$4__sr_LazyRef__ALscodec_Codec(this, componentCodecs$lzy4$2)))(componentCodecs$lzy4$2$1)));
    this.Lapp_api_AppPageSize$__f_derived$SCodecCodecbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$__f_derived$SCodecCodec$lzy1;
});
$c_Lapp_api_AppPageSize$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_api_AppPageSize$$anon$1__f__$ordinal$1;
});
var $d_Lapp_api_AppPageSize$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_AppPageSize$, "app.api.AppPageSize$", ({
  Lapp_api_AppPageSize$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_api_AppPageSize$ as $d_Lapp_api_AppPageSize$ };
var $n_Lapp_api_AppPageSize$;
function $m_Lapp_api_AppPageSize$() {
  if ((!$n_Lapp_api_AppPageSize$)) {
    $n_Lapp_api_AppPageSize$ = new $c_Lapp_api_AppPageSize$();
  }
  return $n_Lapp_api_AppPageSize$;
}
export { $m_Lapp_api_AppPageSize$ as $m_Lapp_api_AppPageSize$ };
/** @constructor */
function $c_Lapp_api_AppPageSize$$anon$2() {
}
export { $c_Lapp_api_AppPageSize$$anon$2 as $c_Lapp_api_AppPageSize$$anon$2 };
$c_Lapp_api_AppPageSize$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_AppPageSize$$anon$2.prototype.constructor = $c_Lapp_api_AppPageSize$$anon$2;
/** @constructor */
function $h_Lapp_api_AppPageSize$$anon$2() {
}
export { $h_Lapp_api_AppPageSize$$anon$2 as $h_Lapp_api_AppPageSize$$anon$2 };
$h_Lapp_api_AppPageSize$$anon$2.prototype = $c_Lapp_api_AppPageSize$$anon$2.prototype;
$c_Lapp_api_AppPageSize$$anon$2.prototype.transform__O__O = (function(src) {
  var x = $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize();
  if (((x === null) ? (src === null) : (x === src))) {
    return 25;
  }
  var x$3 = $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize();
  if (((x$3 === null) ? (src === null) : (x$3 === src))) {
    return 50;
  }
  var x$5 = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
  if (((x$5 === null) ? (src === null) : (x$5 === src))) {
    return 100;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(src);
});
var $d_Lapp_api_AppPageSize$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_AppPageSize$$anon$2, "app.api.AppPageSize$$anon$2", ({
  Lapp_api_AppPageSize$$anon$2: 1,
  Lio_scalaland_chimney_Transformer$AutoDerived: 1,
  Lio_scalaland_chimney_Transformer: 1
}));
export { $d_Lapp_api_AppPageSize$$anon$2 as $d_Lapp_api_AppPageSize$$anon$2 };
/** @constructor */
function $c_Lapp_api_AppPageSize$namedEnum$() {
  this.Lapp_api_AppPageSize$namedEnum$__f_byName = null;
  this.Lapp_api_AppPageSize$namedEnum$__f_values$lzy1 = null;
  this.Lapp_api_AppPageSize$namedEnum$__f_valuesbitmap$1 = false;
  $n_Lapp_api_AppPageSize$namedEnum$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_api_AppPageSize$namedEnum$ as $c_Lapp_api_AppPageSize$namedEnum$ };
$c_Lapp_api_AppPageSize$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_AppPageSize$namedEnum$.prototype.constructor = $c_Lapp_api_AppPageSize$namedEnum$;
/** @constructor */
function $h_Lapp_api_AppPageSize$namedEnum$() {
}
export { $h_Lapp_api_AppPageSize$namedEnum$ as $h_Lapp_api_AppPageSize$namedEnum$ };
$h_Lapp_api_AppPageSize$namedEnum$.prototype = $c_Lapp_api_AppPageSize$namedEnum$.prototype;
$c_Lapp_api_AppPageSize$namedEnum$.prototype.byName__sci_Map = (function() {
  return this.Lapp_api_AppPageSize$namedEnum$__f_byName;
});
$c_Lapp_api_AppPageSize$namedEnum$.prototype.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V = (function(x$0) {
  this.Lapp_api_AppPageSize$namedEnum$__f_byName = x$0;
});
$c_Lapp_api_AppPageSize$namedEnum$.prototype.values__sci_Vector = (function() {
  if ((!this.Lapp_api_AppPageSize$namedEnum$__f_valuesbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_Lapp_api_AppPageSize$().values__ALapp_api_AppPageSize());
    this.Lapp_api_AppPageSize$namedEnum$__f_values$lzy1 = $x_1.fromVectorUnsafe__sci_Vector__sci_Vector($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2));
    this.Lapp_api_AppPageSize$namedEnum$__f_valuesbitmap$1 = true;
  }
  return this.Lapp_api_AppPageSize$namedEnum$__f_values$lzy1;
});
$c_Lapp_api_AppPageSize$namedEnum$.prototype.toName__Lapp_api_AppPageSize__T = (function(a) {
  var x = $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize();
  if ((x === a)) {
    return "25";
  }
  var x$3 = $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize();
  if ((x$3 === a)) {
    return "50";
  }
  var x$5 = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
  if ((x$5 === a)) {
    return "100";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$c_Lapp_api_AppPageSize$namedEnum$.prototype.toName__O__T = (function(a) {
  return this.toName__Lapp_api_AppPageSize__T(a);
});
var $d_Lapp_api_AppPageSize$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_AppPageSize$namedEnum$, "app.api.AppPageSize$namedEnum$", ({
  Lapp_api_AppPageSize$namedEnum$: 1,
  Lframework_utils_NamedEnum: 1,
  Lframework_utils_NamedEnum$WithIntRepresentation: 1
}));
export { $d_Lapp_api_AppPageSize$namedEnum$ as $d_Lapp_api_AppPageSize$namedEnum$ };
var $n_Lapp_api_AppPageSize$namedEnum$;
function $m_Lapp_api_AppPageSize$namedEnum$() {
  if ((!$n_Lapp_api_AppPageSize$namedEnum$)) {
    $n_Lapp_api_AppPageSize$namedEnum$ = new $c_Lapp_api_AppPageSize$namedEnum$();
  }
  return $n_Lapp_api_AppPageSize$namedEnum$;
}
export { $m_Lapp_api_AppPageSize$namedEnum$ as $m_Lapp_api_AppPageSize$namedEnum$ };
var $t_Lapp_api_AppPageSize$___25 = null;
function $u_Lapp_api_AppPageSize$___25(x) {
  $t_Lapp_api_AppPageSize$___25 = x;
}
export { $t_Lapp_api_AppPageSize$___25 as $t_Lapp_api_AppPageSize$___25, $u_Lapp_api_AppPageSize$___25 as $u_Lapp_api_AppPageSize$___25 };
var $t_Lapp_api_AppPageSize$___50 = null;
function $u_Lapp_api_AppPageSize$___50(x) {
  $t_Lapp_api_AppPageSize$___50 = x;
}
export { $t_Lapp_api_AppPageSize$___50 as $t_Lapp_api_AppPageSize$___50, $u_Lapp_api_AppPageSize$___50 as $u_Lapp_api_AppPageSize$___50 };
var $t_Lapp_api_AppPageSize$___100 = null;
function $u_Lapp_api_AppPageSize$___100(x) {
  $t_Lapp_api_AppPageSize$___100 = x;
}
export { $t_Lapp_api_AppPageSize$___100 as $t_Lapp_api_AppPageSize$___100, $u_Lapp_api_AppPageSize$___100 as $u_Lapp_api_AppPageSize$___100 };
//# sourceMappingURL=app.api.-App-Page-Size$.js.map
